import { useRef, useState } from "react";
import "../css/carousel.css";

const Carousel = ({ images, onImageClick }) => {
  const carousel = useRef(null);
  const [count, setCount] = useState(0);

  const goTo = (index) => {
    if (!carousel.current) return;
    const width = carousel.current.offsetWidth;
    carousel.current.scrollTo({
      left: width * index,
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  };

  const incrementCarousel = (delta) => {
    const len = images.length || 1;
    const next = (count + delta + len) % len;
    goTo(next);
  };

  return (
    <div className="carousel-container">
      <button
        className="carousel-btn left-btn"
        onClick={() => incrementCarousel(-1)}
        aria-label="Anterior"
        type="button"
      >
        <svg className="icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
        </svg>
        <span className="sr-only">Anterior</span>
      </button>

      <button
        className="carousel-btn right-btn"
        onClick={() => incrementCarousel(1)}
        aria-label="Siguiente"
        type="button"
      >
        <svg className="icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M8.59 16.59 10 18l6-6-6-6-1.41 1.41L13.17 12z"></path>
        </svg>
        <span className="sr-only">Siguiente</span>
      </button>
      <span className="gallery-counter" aria-live="polite">{count + 1} / {images.length}</span>
      <div className="carousel" ref={carousel} onScroll={() => {
        const element = carousel.current;
        if (element?.clientWidth) setCount(Math.round(element.scrollLeft / element.clientWidth));
      }}>
        {images.map((img, idx) => {
          const alt = img.title || `Habitación del Hotel Raglan, foto ${idx + 1}`;
          const isActive = idx === count;
          return (
            <div
              key={`${idx}-${img.title || "slide"}`}
              className={isActive ? "carousel-item active" : "carousel-item"}
            >
              <img
                src={img.src}
                alt={alt}
                onClick={onImageClick ? () => onImageClick(img.src) : undefined}
                className="carousel-image"
                loading="lazy"
                role={onImageClick ? 'button' : undefined}
                tabIndex={onImageClick ? 0 : undefined}
                onKeyDown={(event) => {
                  if (onImageClick && (event.key === 'Enter' || event.key === ' ')) {
                    event.preventDefault();
                    onImageClick(img.src);
                  }
                }}
              />
              {img.title ? <p>{img.title}</p> : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Carousel;
